module.exports = __webpack_public_path__ + "img/next.1bb0b0a3.svg";